import React, { useEffect, useState } from 'react';

import './MUNmain.scss';
import './../../sassStyles/base/_typography.scss';

import image from './../../images/WAS.png';
import iconCalander from './../../images/svg/akar-icons_calendar.svg';
import iconVacancy from './../../images/svg/vacancy icon.svg';
import iconClock from './../../images/svg/ion_time-outline.svg';
import iconLocation from './../../images/svg/akar-icons_location-big.svg';
import iconCalenderClock from './../../images/svg/fluent_calendar-clock-24-regular.svg';
import iconShare from './../../images/svg/Share-blue.svg';
import iconDownload from './../../images/svg/akar-icons_arrow-down (1).svg';
import iconBriefcase from './../../images/svg/bag-icon-white.svg';

function MUNmain() {
  const [mun, setMun] = useState([]);
  const [committee, setCommittee] = useState([]);

  let description;
  let city;
  let location;
  let time;
  let date;
  let vacancy;
  let applicationDate;
  let committeeId;

  useEffect(() => {
    fetch('http://localhost:8080/muns/mun')
      .then((res) => {
        if (res.status !== 200) {
          throw new Error('Failed to fetch mun.');
        }
        return res.json();
      })
      .then((resData) => {
        setMun(resData);

        // console.log('resData:', resData);
        // console.log(mun);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  if (mun.muns) {
    description = mun.muns[0].description;
    city = mun.muns[0].city;
    location = mun.muns[0].location;
    time = mun.muns[0].time;
    date = mun.muns[0].date;
    vacancy = mun.muns[0].vacancy;
    applicationDate = mun.muns[0].applicationDate;
  }

  date = new Date(date).toLocaleDateString('en-us', {
    // weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  // useEffect(() => {
  //   fetch('http://localhost:8080/committees/committee')
  //     .then((res) => {
  //       if (res.status !== 200) {
  //         throw new Error('Failed to fetch committees.');
  //       }
  //       return res.json();
  //     })
  //     .then((resData) => {
  //       setCommittee(resData);

  //       console.log('resData:', resData);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  // if (committee.committees) {
  //   committeeId = committee.committees[0]._id.toString();
  // }

  return (
    <div className="MUN-main">
      <div className="MUN-main__left">
        <div className="MUN-main__image-box">
          <img src={image} alt="" className="MUN-main__image" />
        </div>
        <div className="MUN-main__description-box">
          <p className="MUN-main__description">{description}</p>
          <p className="MUN-main__description">{description}</p>
        </div>
      </div>
      <div className="MUN-main__right">
        <ul className="MUN-main__feature-list">
          <li className="MUN-main__feature-item">
            <div className="feature">
              <div className="feature__icon-box">
                <img src={iconCalander} alt="" className="feature__icon" />
              </div>
              <div className="feature__details">
                <h3 className="feature__title heading-tertiary">
                  Conference Date
                </h3>
                <p className="feature__subtitle">
                  {date}
                  {/* {mun.muns[0].date ? mun.muns[0].date : 'Loading...'} */}
                </p>
              </div>
            </div>
          </li>
          <li className="MUN-main__feature-item">
            <div className="feature">
              <div className="feature__icon-box">
                <img src={iconVacancy} alt="" className="feature__icon" />
              </div>
              <div className="feature__details">
                <h3 className="feature__title heading-tertiary">Vacancy</h3>
                <p className="feature__subtitle">{vacancy} seats left</p>
              </div>
            </div>
          </li>
          <li className="MUN-main__feature-item">
            <div className="feature">
              <div className="feature__icon-box">
                <img src={iconClock} alt="" className="feature__icon" />
              </div>
              <div className="feature__details">
                <h3 className="feature__title heading-tertiary">Duration</h3>
                <p className="feature__subtitle">
                  {time}
                  {/* {mun.muns[0].time ? mun.muns[0].time : 'Loading...'} */}
                </p>
              </div>
            </div>
          </li>
          <li className="MUN-main__feature-item">
            <div className="feature">
              <div className="feature__icon-box">
                <img src={iconLocation} alt="" className="feature__icon" />
              </div>
              <div className="feature__details">
                <h3 className="feature__title heading-tertiary">Venue</h3>

                <p className="feature__location">
                  <span className="feature__location--main">
                    {/* {mun.muns[0].location ? mun.muns[0].location : 'Loading...'} */}{' '}
                    {location},
                  </span>
                  <span className="feature__location--city">
                    {/* {mun.muns[0].city ? mun.muns[0].city : 'Loading...'}, */}{' '}
                    {city}
                  </span>
                  <span className="feature__location--map">
                    View in &nbsp;
                    <a href="#" className="feature__location--link">
                      Maps
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </li>
          <li className="MUN-main__feature-item">
            <div className="feature">
              <div className="feature__icon-box">
                <img src={iconCalenderClock} alt="" className="feature__icon" />
              </div>
              <div className="feature__details">
                <h3 className="feature__title heading-tertiary">
                  Booking Deadline
                </h3>
                <p className="feature__subtitle">
                  {applicationDate}
                  {/* {mun.muns[0].applicationDate
                    ? mun.muns[0].applicationDate
                    : 'Loading...'} */}
                </p>
                <p className="feature__close">
                  Delegate registration closes at 11:59 p.m.
                </p>
              </div>
            </div>
          </li>
        </ul>
        <div className="MUN-main__btn-box">
          <button className="MUN-main__btn MUN-main__btn--download btn">
            Download Itinerary
            <img src={iconDownload} alt="" className="MUN-main__btn--icon" />
          </button>
          <button className="MUN-main__btn MUN-main__btn--briefcase btn">
            Add to My Briefcase
            <img src={iconBriefcase} alt="" className="MUN-main__btn--icon" />
          </button>
        </div>
        <div className="MUN-main__share-box">
          <img src={iconShare} alt="" className="MUN-main__share" />
        </div>
      </div>
    </div>
  );
}

export default MUNmain;
